import { getInitialMonitoringProps } from './helper';
import { ApplicationMonitoring } from '@brahma/utils';

const onError = (error: Error) => {
  // TODO: Send this to error logger once setup
  console.error(error);
};

const applicationMonitoring = new ApplicationMonitoring(
  getInitialMonitoringProps(),
  onError
);

export default applicationMonitoring;
